export class SendEnquiry {
  public FullName: string;  
  public Email: string;
  public EnquiryDetail: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/loggeduser/sendenquiry.ts